"use client";

import React from "react";
import { Clock, Award, GraduationCap } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefitsData = [{
  title: "Consultoria Estratégica",
  description: "Análise técnica detalhada do seu projeto para alinhar expectativas criativas com viabilidade de execução e prazos.",
  icon: Clock
}, {
  title: "Orçamento Detalhado",
  description: "Transparência total com uma proposta comercial estruturada, discriminando cada etapa do processo de produção.",
  icon: Award
}, {
  title: "Cronograma de Produção",
  description: "Um plano de ação claro com marcos definidos, garantindo que você acompanhe cada evolução do seu projeto.",
  icon: GraduationCap
}];
export default function BenefitsOfLearning() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222704" id="o-que-o-cliente-recebe-ao-entrar-em-contato" className="bg-background py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12">
          <div className="md:col-span-4">
            <h2 className="font-default text-foreground text-3xl md:text-[40px] font-bold tracking-tight leading-tight">
              O que você recebe ao entrar em contato
            </h2>
          </div>
          <div className="md:col-span-8">
            <p className="text-muted-foreground max-w-2xl text-lg">
              Iniciamos nossa parceria com um processo consultivo focado em entender a essência da sua marca e os objetivos do seu projeto.
            </p>
          </div>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-12 gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="md:col-span-4 hidden md:block"></div>
          <div className="md:col-span-8 grid grid-cols-1 gap-8">
            {benefitsData.map((benefit, i) => {
            const Icon = benefit.icon;
            return <div data-index={i} key={i} className="h-full">
                  <Card className="bg-card border-border/90 rounded-xl shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-200 ease-out h-full flex flex-col">
                    <CardHeader className="pb-4">
                      <div className="bg-primary/5 w-16 h-16 rounded-2xl flex items-center justify-center mb-6">
                        <Icon className="w-8 h-8 text-primary" strokeWidth={2} />
                      </div>
                      <CardTitle className="font-default text-xl md:text-2xl text-foreground font-bold">
                        {benefit.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="flex-grow">
                      <p className="text-muted-foreground leading-relaxed font-sans">
                        {benefit.description}
                      </p>
                    </CardContent>
                  </Card>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}